enum UsersRoutes {
  Users = 'users',
  Login = 'auth/login',
  AccessLog = 'users/access-log',
}

export default UsersRoutes;
